import './components/common/video-slider';
import './components/common/youtube';
import './components/splide/media-about';
import './pages/catalog';
import { initYoutubeVideos } from './components/common/youtube';

initYoutubeVideos();
